import { moonPath } from './sky-state.js';

// Pixel coordinates shared with the decorative landscape's bottom edge.
// Bearings run N–E–S–W–N; altitude is compressed linearly above that horizon.
export const SKY_HORIZON_BOTTOM = 12;
export function skyProjection(position, width, height) {
  const inset = 12, horizon = height - SKY_HORIZON_BOTTOM;
  return { x: inset + position.azimuth / 360 * (width - inset * 2),
    y: horizon - Math.min(90, Math.max(0, position.altitude)) / 90 * (horizon - 10) };
}

export function skyArtwork(sky, width, height) {
  if (!sky || width < 24 || height < 24) return '';
  const horizon = height - SKY_HORIZON_BOTTOM;
  const body = (name, position) => {
    if (!position.aboveHorizon) return '';
    const {x,y} = skyProjection(position,width,height);
    return `<g class="sky-body sky-body-${name}" transform="translate(${x} ${y})">${name === 'sun'
      ? '<circle class="sky-sun-glow" r="8"/><circle class="sky-sun" r="4.5"/>'
      : `<circle class="sky-moon-dark" r="6"/><path class="sky-moon" d="${moonPath(position.phase)}"/><circle class="sky-moon-rim" r="6"/>`}</g>`;
  };
  return `<svg viewBox="0 0 ${width} ${height}" width="${width}" height="${height}"><path class="sky-horizon" d="M12 ${horizon} H${width-12}"/><g class="sky-stars" opacity="${sky.lighting === 'night' ? .8 : sky.lighting === 'day' ? 0 : .25}">${[[.05,.1],[.18,.6],[.33,.05],[.51,.4],[.69,.02],[.82,.65],[.95,.15]].map(([x,y]) => `<circle cx="${12+x*(width-24)}" cy="${5+y*(horizon-12)}" r=".65"/>`).join('')}</g>${body('sun',sky.sun)}${body('moon',sky.moon)}<g class="sky-directions">${['N','E','S','W','N'].map((label,i)=>`<text x="${12+i/4*(width-24)}" y="${height-2}">${label}</text>`).join('')}</g></svg>`;
}
